import React from 'react';
import {SkeletonComponent} from './skeleton.style'


export const Skeleton = (props) => (
  <SkeletonComponent {...props}/>
);
